export const BLOB_CACHE_NAME = 'ob-logs-blob-cache';
const MEGABYTES_LIMIT = 15;
const BYTES_PER_KILOBYTE = 1024;
export const BLOB_CACHE_MAX_SIZE_BYTES = MEGABYTES_LIMIT * BYTES_PER_KILOBYTE * BYTES_PER_KILOBYTE;
export const CACHE_KEY_PREFIX = 'https://ob-logs-blob-cache/';

export const CACHE_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  BLOB_SIZE: 'X-Blob-Size',
  CACHED_AT: 'X-Cached-At',
};
